import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html'
})

export class NavMenuComponent implements OnInit, OnDestroy {
    constructor() { }

    ngOnInit() {

    }

    ngOnDestroy() {

    }
}







// WEBPACK FOOTER //
// ./client/app/internal/accmgr/ba/nav-menu/nav-menu.component.ts